<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>统计</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">统计列表</div>
        <!-- <Input
          search
          placeholder="请输入关键字"
          v-model="search"
          @on-search="searchPro"
          style="width:230px;margin-top:20px;"
        /> -->

      </div>
      <div class="header-tool-box">
        <!-- <div class="htb-item" @click="ok">
          <span class="htb-add">+</span>
          <span>导入展商</span>
        </div>-->
        <div class="htb-item" @click="$router.push('/host/index/set/export-talk-details')">
          <span class="htb-add">+</span>
          <span>洽谈明细导出</span>
        </div>
        <div class="htb-item" @click="$router.push('/host/index/set/export-talk')">
          <span class="htb-add">+</span>
          <span>洽谈总量导出</span>
        </div>
        <div class="htb-item" @click="$router.push('/host/index/set/export-talk-category')">
          <span class="htb-add">+</span>
          <span>洽谈各类别导出</span>
        </div>

      </div>
    </div>
     <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="洽谈前十展商" name="1">
           <ex></ex>
        </TabPane>
        <TabPane label="洽谈前十展品" name="2">
           <pro></pro>
        </TabPane>
        <TabPane label="洽谈前十供需" name="3">
           <supply></supply>
        </TabPane>
        <TabPane label="洽谈总量" name="4">
          <category></category>
        </TabPane>
        <TabPane label="洽谈类别" name="5">
          <talkCategory></talkCategory>
        </TabPane>
        <TabPane label="总人数" name="6">
          <peopleNumber></peopleNumber>
        </TabPane>
        <TabPane label="总人次" name="7">
          <person></person>
        </TabPane>
      </Tabs>
    </div>
   
    <!-- 修改展商置顶 -->
    

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ex from "./components/ex.vue";
import pro from "./components/pro.vue";
import supply from "./components/supply.vue";
import category from "./components/category.vue";
import peopleNumber from "./components/Number_people.vue";
import person from "./components/person.vue";
import talkCategory from "./components/talkCategory.vue";
import echarts from 'echarts'
export default {
  name: "host-ex-list",
  data() {
    return {
      search: "",
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      showTabs: "1",
      
      
    };
  },
  components: {
    ex,
    pro,
    supply,
    category,
    talkCategory,
    peopleNumber,
    person
  },
  computed: {
    
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    

  },
  mounted(){

    
  },
  methods: {
    ...mapActions({
     
      getSearch: "hostCommonModule/getSearch",
      addTask:"hostCommonModule/addTask"
    }),
    async init() {
              // 基于准备好的dom，初始化echarts实例
       
    },

    // changePage(e) {
    //   this.pageIndex = e;
    //   this.init();
    // },
    // changePageSize(e) {
    //   this.pageSize = e;
    //   this.init();
    // },
    switchBrand(name){
        if(name===1){
            this.showTabs=1
        }
        if(name===2){
            this.showTabs=2
        }
    },
    async count(){
      
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}
/deep/ .resetModal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal{
    top: 0;
  }
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
</style>

